import React, { useEffect, useState } from 'react';
import { Button, CircularProgress, Paper, Typography } from '@material-ui/core';
import { useStyles } from './styles';
import Cookies from 'universal-cookie';
import Comunicado_controller from '../../../controllers/comunicado';
import Config from '../../../controllers/config';

const goBack = () => {
  if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
    history.go(-2);
  } else {
    history.back();
  }
};

export default function AnnouncementPage(props: any) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [hasFile, setHasFile] = useState(false);
  const [hasLink, setHasLink] = useState(false);
  const [data, setData] = useState<any>({});
  const [link, setLink] = useState('');
  const [content, setContent] = useState('');

  const getAnnouncement = async () => {
    setLoading(true);
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    const filters = {
      id: props.params.id
    };

    const r_arquivo = await Comunicado_controller.get(token, filters);
    const j_r_arquivo = JSON.parse(r_arquivo.body);
    setData(j_r_arquivo.itens[0]);
    if (j_r_arquivo.itens[0].anexo && j_r_arquivo.itens[0].diretorio !== 'https://') {
      setHasFile(true);
      const local = j_r_arquivo.itens[0].diretorio.split(';@Assets');
      var filename = `${props.route.link}.pdf`;
      filename = local[1].split('/');
      filename = filename[2];
      const url = `${Config.URL_BACKEND}/${props.route.link}/arquivos/${props.params.id}/${token}/${filename}`;
      setContent(url);
    } else if (j_r_arquivo.itens[0].diretorio !== 'https://') {
      setHasLink(true);
      setLink(j_r_arquivo.itens[0].diretorio);
    }

    setLoading(false);
  };

  useEffect(() => {
    getAnnouncement();
  }, []);

  return (
    <div className="container">
      <Button
        className={classes.backButton}
        variant="contained"
        color="primary"
        onClick={() => {
          goBack();
        }}
      >
        {'Voltar'}
      </Button>
      <br />
      <br />

      <Paper className={classes.root}>
        {loading && <CircularProgress />}
        {!loading && (
          <div>
            <Typography variant="h6">{data.titulo}</Typography>
            <Typography variant="body1" component="p" className={classes.description}>
              {data.descricao}
            </Typography>
          </div>
        )}
        {!loading && hasFile && <iframe src={content} className={classes.imagem} />}
        {!loading && hasLink && (
          <div>
            <Typography variant="body1" component="p">
              Este comunicado possui um link em anexo. <span>&nbsp;</span>
              <span className={classes.link} onClick={() => window.open(link, '_blank')}>
                Clique aqui
              </span>
              <span>&nbsp;</span>
              para acessá-lo.
            </Typography>
          </div>
        )}
      </Paper>
    </div>
  );
}
